import { WebElement } from './web-element';

export class WebTarger {
  public id: number;
  public name: string;
  public url: string;
  public orderElement: string;
  public webElements: WebElement[] = [];
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/_model/web-targer.ts